// extracted by mini-css-extract-plugin
export default {"container":"styles_container__fMYGW","markdown-wrapper":"styles_markdown-wrapper__xGhuR","dynamic-block":"styles_dynamic-block__EXLM6","placeholder":"styles_placeholder__5Hmpv"};